export function getElementMargin(el: HTMLElement) {
  if (!window.getComputedStyle) {
    return makeMarginObject(0, 0, 0, 0);
  }

  const style = window.getComputedStyle(el);

  return makeMarginObject(
    parseInt(style.marginLeft, 10) || 0,
    parseInt(style.marginRight, 10) || 0,
    parseInt(style.marginTop, 10) || 0,
    parseInt(style.marginBottom, 10) || 0,
  );
}

function makeMarginObject(marginLeft: number, marginRight: number, marginTop: number, marginBottom: number) {
  return {
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
  };
}
